














































import Vue from "vue";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default Vue.extend({
  name: "ProductCampaignPage",
  components: {
    ProductCampaignList: () => import("./productCampaignList.vue"),
    ProductCampaignAdd: () => import("./productCampaignAdd.vue"),
    FamersCampaignModal: () =>
      import("@/views/full/shared/farmersCampaign_modal.vue"),
    ProductCampaignLivestreamModal: () =>
      import("./productCampaignLivestrem_modal.vue"),
    CloseDateModal: () =>
      import("./closeDateModal.vue")
  },
  data() {
    return {
      searchDebounce: null,
      search: "",
      selected: [],
      file: "",
      upLoading: "",
      filter: null
    };
  },
  computed: {
    ...mapGetters({
      selectedProductCampaign: "productCampaign/selected"
    })
  },
  methods: {
    ...mapActions({
      getProductCampaignList: "productCampaign/getItems",
      productCampaign_deleteItems: "productCampaign/deleteItems",
      productCampaign_searchItems: "productCampaign/search",
      productCampaign_filterItems: "productCampaign/filter",
      checkShowMenu: "menu/checkShowMenu"
    }),
    ...mapMutations({
      resetQuery: "productCampaign/resetQuery",
      openModalAdd: "productCampaign/setAddItemModal"
    }),
    filterChanged(value: string) {
      if (value == "ALL") {
        this.productCampaign_filterItems({
          type: undefined
        });
        return;
      }
      this.productCampaign_filterItems({
        type: value
      });
    },

    searchChanged() {
      if (this.searchDebounce) clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        this.productCampaign_searchItems(this.search);
      }, 500);
    },
    removeSelected() {
      this.productCampaign_deleteItems({
        idItems: this.selectedProductCampaign,
        textMess: "vòng quay"
      });
    },
    upload() {},
    getCSVTemplate() {},
    showModalAct() {},
    handleOpenModalAdd() {
      this.openModalAdd({ show: true });
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm: any) => {
      vm.resetQuery();
      vm.getProductCampaignList();
      vm.$store.dispatch("campaign/getList", {
        query: { limit: 0 }
      });
    });
  },
  async created() {
    const res = await this.checkShowMenu(this.$route.fullPath);
    if (!res) this.$router.push({ name: "permissionDenied" });
  }
});
